import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Hammer, ArrowLeft } from 'lucide-react';
import { V2_BASE } from '../config';
import './ComingSoonPage.css';

const ComingSoonPage = ({ title = 'Sezione', subtitle }) => {
  const navigate = useNavigate();
  return (
    <div className="nfx-soon">
      <div className="nfx-soon-card">
        <span className="nfx-soon-icon"><Hammer size={26} /></span>
        <span className="nfx-soon-badge">In arrivo nella v2</span>
        <h2 className="nfx-soon-title">{title}</h2>
        <p className="nfx-soon-sub">
          {subtitle || 'Questa sezione sarà ridisegnata con la nuova estetica NeoFlux.'}
        </p>
        <button className="nfx-soon-back" onClick={() => navigate(V2_BASE)}>
          <ArrowLeft size={16} /> Torna alla pagina iniziale
        </button>
      </div>
    </div>
  );
};

export default ComingSoonPage;
